import React from "react";

const NotFound = () => {
  return (
    <div
      className="container mt-5 col-10 col-sm-8 col-md-6 col-lg-5"
      style={{ paddingBottom: "12rem" }}
    >
      <div className="text-center mb-5 alert alert-primary">
        <p>Cette page n'existe pas</p>
      </div>
    </div>
  );
};

export default NotFound;
